import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "baselineframegridrelativeoption"
    }}>{`BaselineFrameGridRelativeOption`}</h1>
    <p>{`The starting point used to calculate the baseline frame grid offset.`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TOP_OF_PAGE`}</strong>{` = 1163161458`}</p>
      <p parentName="blockquote">{`Offsets the grid from the top of the page.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TOP_OF_MARGIN`}</strong>{` = 1163161453`}</p>
      <p parentName="blockquote">{`Offsets the grid from the top margin of the page.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TOP_OF_FRAME`}</strong>{` = 1163161446`}</p>
      <p parentName="blockquote">{`Offsets the grid from the top of the text frame.`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TOP_OF_INSET`}</strong>{` = 1163161449`}</p>
      <p parentName="blockquote">{`Offsets the grid from the top inset of the text frame.`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      